import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import Co2Calculator from './components/main';
import ReactShadowRoot from 'react-shadow-root';
import styles from '../../style/sass/main.sass';
import * as config from '../../../config.json';

const ROOT = document.getElementById('co2CalculatorContainer');

// Initialize global state within App
class App extends React.Component {
  constructor(props) {
    super(props);

    // Set default API endpoint for ACF controlled installation
    let endPoint = '/wp-json/acf/v3/options/co2-options-page';

    // Set endpoint to klimaatplein.com incase the client wants to use that
    if (this.props.useCoreHost) endPoint = config.coreEndpoint;

    this.state = {
      EndPoint: endPoint,
      data: {},
    };

    // Create reference to the root object
    this.co2Root = React.createRef();
  }

  async componentDidMount() {
    const { EndPoint } = this.state;

    // Get the required data from the API endpoint
    let response = await fetch(`${EndPoint}`);
    let JsonData = await response.json();

    // Put the data in the top level state
    this.setState({ data: JsonData });
  }

  render() {
    return (
      <div>
        <ReactShadowRoot>
          <style>{styles.toString()}</style>
          <Co2Calculator
            endPoint={this.state.EndPoint}
            data={this.state.data}
            ref={this.co2Root}
            forwardRef={this.co2Root}
          />
        </ReactShadowRoot>
      </div>
    );
  }
}

// Check if useCoreHost is enabled
let useCoreHost = false;
if (ROOT.dataset.useCoreHost) useCoreHost = true;

// Render App component to page
ReactDOM.render(<App useCoreHost={useCoreHost} />, ROOT);
